<div class="l_flex m-l_flex scroll-container">
  <div
    class="scroll-container__content l_flex m-l_flex m-guts-p-l-half m-guts-p-t-half full-width"
  >
    <ng-content></ng-content>
    <ng-container
      *ngFor="let i of emptyTileCount; let last = last"
      data-dgat="profile-card-carousel-05f"
    >
      <div
        class="profile-empty__tile"
        [ngClass]="{
          'guts-m-r-3': !last,
          'guts-p-r-half': last
        }"
      ></div>
    </ng-container>
  </div>
</div>
